import React from 'react';
import { TabsContainer } from './styles';
import Mockups from './Mockups';
import Projects from './Projects';
import { Tab } from '@gerdau/hefesto/Tab';
import { TabItemProps } from '@gerdau/hefesto/Tab/Tab.types';

export enum EProjectsMockupsTab {
  MOCKUPS = 'mockups',
  PROJECTS = 'projects'
}

export interface IProjectsMockupsTab {
  name: string;
  tab: EProjectsMockupsTab;
}

interface ProjectsMockupTabsProps {
  selectedTab: EProjectsMockupsTab;
  setSelectedTab: (tab: EProjectsMockupsTab) => void;
}

const ProjectsMockupTabs: React.FC<ProjectsMockupTabsProps> = ({
  selectedTab,
  setSelectedTab
}) => {
  const tabs: TabItemProps[] = [
    {
      key: EProjectsMockupsTab.MOCKUPS,
      name: 'Maquetes',
      content: <Mockups />
    },
    {
      key: EProjectsMockupsTab.PROJECTS,
      name: 'Projetos',
      content: <Projects />
    }
  ];

  const onTabClick = (tab: string) => {
    setSelectedTab(tab as EProjectsMockupsTab);
  };

  return (
    <TabsContainer>
      <Tab tabItems={tabs} activeKey={selectedTab} onChange={onTabClick}></Tab>
    </TabsContainer>
  );
};

export default ProjectsMockupTabs;
